export default "__VITE_ASSET__BYYHqe4Q__"